import { IntlMessageId } from "src/assets/localization/types";

export enum BugModalInvoker {
  NavMenu = "navMenu",
  Toast = "toast",
  ErrorBoundary = "errorBoundary",
}

// Error, který vyhodí error boundary
export type BoundaryErrorData = {
  message: string;
  name: string | IntlMessageId;
  stack?: string;
  componentStack: string;
};

// Error který se stane mimo render komponenty
export type StandardErrorData = {
  message: string;
  name: string | IntlMessageId;
  stack: string;
  componentStack?: string;
};

export type ErrorData = StandardErrorData | BoundaryErrorData;

export type ErrorEntity = {
  timeOfError: string;
  bugReported: boolean;
  handledBy: BugModalInvoker;
  errorData: ErrorData | ErrorData[];
};
